
const ua = navigator.userAgent
const isAndroidApp = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;

import { Options, Vue } from "vue-class-component";
import { getQuestion, getVideoInfo, getCorrect } from "@/api/index";
import mobileNativeSDK from '@/assets/js/mobileNativeSDK.js'
import { Dialog } from "vant";
import { isNewBridgeView } from '@/assets/js/utils.js'
import { getClientCommonMessage, getData, playVideo } from '@/utils/nativeFn'

@Options({
  components: {},
})
export default class Home extends Vue {
  isLoading: boolean = false
  qrCode: string = ''
  hasResolve: boolean = true // 是否有解析
  hasVideo: boolean = true // 是否有视频
  videoData: any = null // 视频信息
  nryContent: any = null // 解析信息
  isLoadingComplete: boolean = false
  queryDone: boolean = false
  mounted() {
    if (isNewBridgeView()) {
      this.initNewData()
    } else {
      window['$eventBus'].addListener('receiveAndroidMsg', this.receiveAndroid);
      this.getNativeData()
    }
  }
  // 新的dsbridge初始化
  initNewData() {
    this.getNewNativeData()
    let num = 0
    let timer = setInterval(() => {
      if(this.queryDone) {
        clearInterval(timer)
        return
      } else {
        this.getNewNativeData()
        num++
        if (num === 10) {
          clearInterval(timer)
          this.getVideoInfo()
        }
      }
    }, 500)
  }
  // 安卓监听消息
  receiveAndroid(res) {
    console.log('收到传递过来的安卓消息=====> ', typeof res)
    let androidResult: any = JSON.parse(res)
    if (androidResult.event == 'getData') {
      this.detailNativeData(androidResult.dataJson)
    }
  }
  // 播放视频
  playVideo() {
    const params = {
      resource_vod_src: this.videoData.resource_vod_src,
      resource_src: this.videoData.resource_src,
      column_id: '0',
      min_column_id: '0',
      content_id: this.videoData.content_id,
      unionid: this.videoData.unionid,
      sn: this.videoData.sn || '',
      is_dot: this.videoData.is_dot,
      title: this.videoData.title
    }
    // console.log(JSON.stringify(params), '扫码看视频视频信息')
    // 唤起native端的播放器
    if (isNewBridgeView()) {
      playVideo(params, (res) => {
        console.log('调用视频播放', res)
      })
    } else {
      mobileNativeSDK.playVideo(params, (res: any) => {
        console.log(res);
      });
    }
  }
  // 根据二维码信息获取视频地址
  getVideoInfo() {
    if (!this.qrCode) {
      Dialog.alert({
        message: '未识别到二维码信息',
        cancelButtonText: '知道了'
      })
      return
    }
    const data = {
      scan_string: this.qrCode,
    };
    this.isLoading = true
    getVideoInfo(data)
      .then((res) => {
        if (res.data.code === 100101) {
          this.isLoading = false // loading消失
          return
        }
        if (res.data.code !== 0) {
          this.isLoading = false
          Dialog.alert({
            message: res.data.message?res.data.message: '获取视频地址失败',
            cancelButtonText: '知道了'
          })
          return
        }
        // 返回数据正常
        this.videoData = res.data.data;
        if (!res.data.data.resource_src && !res.data.data.resource_vod_src) { // 没有返回视频地址
          this.hasVideo = false
          this.getQuestionData()
          return
        }
        this.isLoadingComplete = true
        this.isLoading = false
      })
      .catch((err) => {
        this.isLoading = false
        console.log(err, "获取视频数据失败");
      });
  }
  // 新端获取数据
  getNewNativeData() {
    if (this.queryDone) {
        return
    }
    getClientCommonMessage({}, (res) => {
      console.log(res,'h5调用端上getClientCommonMessage')
      res.token && localStorage.setItem('tal_token', res.token)
      res.user_id && localStorage.setItem('TAL_UID_TMP', res.user_id)
      res.services_version = localStorage.setItem('service_version', res.service_version)
      this.queryDone = true
      getData((detailRes) => {
        if (!detailRes || !detailRes.qr_code) {
          Dialog.alert({
            message: '未获取到二维码信息',
            cancelButtonText: '知道了'
          })
          return
        }
        this.qrCode = detailRes.qr_code
        this.getVideoInfo()
      })
    })
  }
  // 从端上获取数据
  getNativeData() {
    mobileNativeSDK.getData((res) => {
      if (!isAndroidApp) {
        console.log(res, '11111')
        this.detailNativeData(res)
      }
    })
  }
  // 处理端上数据
  detailNativeData(res) {
    if (!res || !res.qr_code) {
      Dialog.alert({
        message: '未获取到二维码信息',
        cancelButtonText: '知道了'
      })
      return
    }
    if (localStorage.getItem('tal_token') !== res.token) {
      localStorage.setItem('tal_token', res.token)
    }
    if (res.service_version) {
      localStorage.setItem('service_version', res.service_version)
    }
    this.qrCode = res.qr_code
    this.getVideoInfo()
  }
  // 获取题目解析
  getQuestionData() {
    if (!this.qrCode) {
      return
    }
    const data = {
      scan_string: this.qrCode,
    };
    getQuestion(data)
      .then((res) => {
        this.isLoadingComplete = true
        this.isLoading = false
        if (res.data.code != 0) {
          this.hasResolve = false
          Dialog.alert({
            message: res.data.message? res.data.message: '获取题目解析失败',
            confirmButtonText: '知道了'
          })
          return
        }
        if (JSON.stringify(res.data.data) == "{}" || !res.data.data.question_detail || JSON.stringify(res.data.data.question_detail) == "{}") {
          // 解析和题目内容为空
          this.hasResolve = false
          return
        }
        this.nryContent = res.data.data;
        this.$nextTick(() => {
          let questionTitleDom: any = document.getElementById('question_title');
          let questionAnalysisDom: any = document.getElementById('question_analysis');
          try {
            questionTitleDom.innerHTML = (window as any).TalqsTemplate.renderPartialComponent('question', this.nryContent.question_detail, {
              hideDifficulty: true
            });
            questionAnalysisDom.innerHTML = (window as any).TalqsTemplate.renderPartialComponent('questionAnalyze', this.nryContent.question_detail, {
              hideDifficulty: true
            });

            (window as any).MathJax.Hub.Queue(['Typeset', (window as any).MathJax.Hub, document.getElementById('question_title')]);
            (window as any).MathJax.Hub.Queue(['Typeset', (window as any).MathJax.Hub, document.getElementById('question_analysis')]);

            (window as any).TalqsTemplate.autoLayout();
            
          } catch (e) {
            console.log('error', e);
          }
        });
      })
      .catch((err) => {
        console.log(err, 'questionError')
        this.isLoading = false
        this.hasResolve = false
      });
  }
}
